import { combineReducers } from 'redux';
import user from './user';
import problem from './problem';
import problemDetail from './problemDetail';
import product from './product';
import features from './features'
import productModal from './productModal';
import domainModal from './domainModal';
import featuresDetail from './featuresDetail';
import appDevelopPannel from './appDevelopPannel';
import appPannel from './appPannel';
import network from './network';
import hardware from './hardware';
import productUpgradeModal from './productUpgradeModal';
import stat from './stat';
import featureEdit from './featureEdit';
import virtualDevice from './virtualDevice';
import application from './application';
import applicationBuild from './applicationBuild';
import applicationGuide from './applicationGuide';
import manageAccount from './manageAccount';
import manageRole from './manageRole';
import manageCategory from './manageCategory';
import manageModule from './manageModule';
import managePannel from './managePannel';
import queryUser from './queryUser';
import queryDevice from './queryDevice';
import firmware from './firmware';
import firmwareEdit from './firmwareEdit';
import eventConfig from './eventConfig';
import eventConfigEdit from './eventConfigEdit';
import networkConfig from './networkConfig';
import hardwareDev from './hardwareDev';
import release from './release';
import appMange from './appMange';
import categoryModel from './categoryModel';
import standardPanel from './standardPanel';
import appPannelNew from './appPannelNew';
import customizePanel from './customizePanel';
import tagsManage from './tagsManage';


export default combineReducers({
    user,
    problem,
    problemDetail,
    product,
    productModal,
    features,
    domainModal,
    featuresDetail,
    appDevelopPannel,
    appPannel,
    network,
    hardware,
    productUpgradeModal,
    stat,
    featureEdit,
    virtualDevice,
    application,
    applicationBuild,
    applicationGuide,
    manageAccount,
    manageRole,
    manageCategory,
    manageModule,
    managePannel,
    queryUser,
    queryDevice,
    firmware,
    firmwareEdit,
    eventConfig,
    eventConfigEdit,
    networkConfig,
    hardwareDev,
    release,

    appMange,
    categoryModel,
    standardPanel,
    customizePanel,
    tagsManage,
    appPannelNew
});
